/**
 * Search mixin
 * @mixin
 */
export default {
	data() {
		return {
			searchText: null,
		}
	},

	methods: {
		onSearch(searchText) {
			this.searchText = searchText
			this.count = -1
		},
	},
}
